export default __webpack_public_path__ + "static/teaBag2-3d3f65798af5f295c1728cc5d66b2050.png";